import { Table, TableBody, TableCaption, TableCell, TableFooter, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { CheckpointEntry } from '@/features/desktop/types/attendee-details';
import { getLabelValue } from '@/utils/getLabelValue';
import { format } from 'date-fns';

interface CheckpointEnteriesTableProps {
  checkpointEnteries: CheckpointEntry[];
}

export function CheckpointEnteriesTable({ checkpointEnteries }: CheckpointEnteriesTableProps) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead className="text-[12px] p-2 ">{getLabelValue('Timestamp')}</TableHead>
          <TableHead className="text-[12px] max-w-[100x] p-2">{getLabelValue('Event')}</TableHead>
          <TableHead className="text-[12px] max-w-[64px] p-2 truncate">{getLabelValue('DirectionLabel')}</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {checkpointEnteries.map(entery => (
          <TableRow key={entery.checkpointDataId}>
            <TableCell className="text-[12px] p-2 max-w-[90px] truncate">{format(entery.timestamp, 'yyyy-MM-dd HH:mm')}</TableCell>
            <TableCell className="p-2">
              <p className="text-[12px] line-clamp-2 max-w-[100px] break-words overflow-hidden">{entery.eventName}</p>
            </TableCell>
            <TableCell className="text-[12px] p-2 max-w-[64px] truncate items-center">
              {entery.direction == 1 ? getLabelValue('DirectionIn') : getLabelValue('DirectionOut')}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
